import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76d75bbd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 p-d-flex p-justify-center p-mt-6" }
const _hoisted_2 = { class: "p-mt-4 p-mb-4 p-grid p-col-12 p-lg-6" }
const _hoisted_3 = { class: "p-d-flex p-flex-wrap" }
const _hoisted_4 = { class: "p-d-flex p-flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "your verified Price", -1))
const _hoisted_6 = { class: "span-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Requested by", -1))
const _hoisted_8 = { class: "brand" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "p-d-flex p-flex-wrap p-justify-between p-col-12 p-mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h6", null, "Distribution platform")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Distribution period", -1))
const _hoisted_14 = { class: "span-text" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h6", null, "Distribution across"),
  /*#__PURE__*/_createElementVNode("span", { class: "span-text" }, "EU West")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-mt-4" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Request Note")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_latest_content_item = _resolveComponent("latest-content-item")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_latest_content_item, {
          item: _ctx.payload?.item,
          favorites: false,
          "is-favorite": false
        }, null, 8, ["item"]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.nOffer?.price) + " " + _toDisplayString(_ctx.payload?.item?.campaignId?.budget?.currency), 1),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_ctx.data?.request?.brand?.photo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.data?.request?.brand?.photo,
                  class: "photo"
                }, null, 8, _hoisted_9))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data?.request?.brand?.name), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.data?.request?.duration?.period) + " " + _toDisplayString(_ctx.data?.request?.duration?.type), 1)
        ]),
        _hoisted_15
      ]),
      _hoisted_16,
      _createElementVNode("div", {
        class: _normalizeClass(["p-d-flex p-justify-between p-col-12 p-mt-6", _ctx.working && 'disabled'])
      }, [
        _createVNode(_component_Button, {
          label: "Reject offer",
          class: "p-button-link p-text-uppercase p-mr-6",
          style: {"color":"#162020"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectOption('reject')))
        }),
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Counter offer (1)",
            class: "red-button p-text-uppercase p-mr-6",
            style: {"background":"white","color":"#162020"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectOption('counter')))
          }),
          _createVNode(_component_Button, {
            label: "Accept request",
            class: "red-button p-text-uppercase p-mr-6",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectOption('accept')))
          })
        ])
      ], 2)
    ])
  ]))
}